import {useState, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';
import {getFile, postFile} from '../store/request';
import {downloadFileApi} from './api';
import {createFileUrl} from './misc';

export const useUploadFile = ({cbOnSuccess} = {}) => {
  const dispatch = useDispatch();
  const {uuid} = useParams();
  const [file, setFile] = useState({});
  const [uploading, setUploading] = useState({});
  const [uploaded, setUploaded] = useState({});

  const fetch = useCallback(
    async (type, fileId = undefined, storageKey = undefined) => {
      const key = storageKey ?? fileId ?? type;

      let fileData = {id: fileId};

      if (!fileId) {
        fileData = await dispatch(getFile(type, uuid));
      }

      if (fileData.id) {
        const downloadedFile = await downloadFileApi(fileData.id, uuid);

        setFile(prev => ({
          ...prev,
          [key]: [
            {
              file_name: downloadedFile?.headers['x-filename'],
              content: createFileUrl(downloadedFile.data),
            },
          ],
        }));
        setUploaded(prev => ({...prev, [key]: true}));
      } else {
        setUploaded(prev => ({...prev, [key]: false}));
      }
    },
    [dispatch, uuid],
  );

  const upload = useCallback(
    async (file, type, fileParams = undefined, fileId = undefined) => {
      const key = fileId ?? type;
      setUploading(prev => ({...prev, [key]: true}));

      const response = await dispatch(
        postFile(
          {
            file_name: file.name,
            file_content: file.base64,
            type,
            ...(fileParams && fileParams),
          },
          uuid,
        ),
      );

      if (response && !response.error) {
        cbOnSuccess && cbOnSuccess();
        await fetch(type, response.id, key);
      }

      setUploading(prev => ({...prev, [key]: false}));
    },
    [dispatch, cbOnSuccess, fetch, uuid],
  );

  return {
    file,
    uploaded,
    uploading,
    fetch,
    upload,
  };
};
